import type { RitualSnapshot } from "../types";
import { snapshotFromUnknown } from "./legacyMigration";

export interface RitualExport {
  app: "ritual";
  version: 2;
  exported_at: string;
  snapshot: RitualSnapshot;
}

export function buildExport(snapshot: RitualSnapshot): string {
  const payload: RitualExport = {
    app: "ritual",
    version: 2,
    exported_at: new Date().toISOString(),
    snapshot,
  };

  return JSON.stringify(payload, null, 2);
}

export function parseImport(text: string): RitualSnapshot {
  let parsed: unknown;
  try {
    parsed = JSON.parse(text);
  } catch {
    throw new Error("This is not valid Ritual JSON.");
  }

  const snapshot = snapshotFromUnknown(parsed);

  if (!Array.isArray(snapshot.nutrition) || !Array.isArray(snapshot.grooming)) {
    throw new Error("The import file is missing Ritual data.");
  }

  return snapshot;
}
